import { Link, useHistory, useLocation } from 'react-router-dom';
import * as React from 'react';

import { ClickTracker } from 'bernie-analytics';
import { updateSearch } from 'bernie-core';

import { UitkIcon } from 'uitk-react-icons';
import { UitkMoreInfoTrigger } from 'uitk-react-more-info-trigger';

import { DisclaimerDialog } from 'src/common/components/common/disclaimer-dialog';
import { StrikeoutPrice } from './strikeout-price';

const LinkTracked = ClickTracker(Link);

const KEYCODE_SPACE = 32;

export interface StrikeoutPriceAndInfoContainerProps {
  strikeoutDisclaimer?: string;
  strikeOut?: string;
  dialogId?: string;
  handleClose?: () => void;
  wrapPrice?: boolean;
  dialogType?: string;
  layerId?: string;
}

export const StrikeoutPriceAndInfoContainer: React.FunctionComponent<StrikeoutPriceAndInfoContainerProps> = ({
  strikeoutDisclaimer,
  strikeOut,
  dialogId,
  handleClose,
  wrapPrice,
  dialogType,
  layerId,
}) => {
  const disclaimerTrigger = React.useRef(null);
  const history = useHistory();
  const location = useLocation();

  const onDisclaimerDialogClose = () => {
    handleClose();
    if (
      disclaimerTrigger &&
      disclaimerTrigger.current &&
      disclaimerTrigger.current.focus &&
      typeof disclaimerTrigger.current.focus === 'function'
    ) {
      disclaimerTrigger.current.focus();
    }
  };

  const handleOpen = e => {
    e.preventDefault();
    updateSearch({ history, location, newParams: { pwaDialog: `${dialogId}` } });
  };

  const triggerRef = disclaimerTriggerRef => {
    disclaimerTrigger.current = disclaimerTriggerRef;
  };

  // Allow keyboard-centric users to activate the dialog via spacebar, without causing a scroll.
  const linkOnKeyDown = e => {
    if (e.keyCode === KEYCODE_SPACE) {
      e.preventDefault();
      e.target.click();
    }
  };

  return (
    <React.Fragment>
      {strikeoutDisclaimer ? (
        <React.Fragment>
          <UitkMoreInfoTrigger>
            <LinkTracked
              linkName="Price Disclaimer Dialog"
              rfrr=".Price.DisclaimerDialog"
              role="button"
              onClick={handleOpen}
              innerRef={triggerRef}
              onKeyDown={linkOnKeyDown}
            >
              <UitkIcon name="info_outline" className="pwa-theme--grey-700" />
              <StrikeoutPrice {...{ strikeOut, wrapPrice }} />
            </LinkTracked>
          </UitkMoreInfoTrigger>
          <DisclaimerDialog
            dialogType={dialogType}
            disclaimerText={strikeoutDisclaimer}
            innerHTML={true}
            layerId={`price-disclaimer-dialog${layerId ? `-${layerId}` : ''}`}
            disclaimerTextId="price-disclaimer-text"
            handleClose={onDisclaimerDialogClose}
            {...{ dialogId }}
          />
        </React.Fragment>
      ) : (
        <StrikeoutPrice {...{ strikeOut, wrapPrice }} />
      )}
    </React.Fragment>
  );
};
